import { ListElement } from './style';

export interface ListProps {
    children?: React.ReactNode;
    numbered?: boolean;
    role?: string;
}

const List = ({ numbered, ...props }: ListProps) => <ListElement as={numbered ? 'ol' : 'div'} {...props} />;

export default List;
